interface Chair {
  name: string,
  file: string,
  id: string,
  config: Array<unknown>,
  colors: unknown,
  scale: number
}

interface VariantMaterial {
  color: number,
  emissive?: number,
  metalness: number,
  roughness: number
}

const Background = {
  DARK: '#333',
  LIGHT: '#fff'
}

const Floor = {
  DARK: '#040404',
  LIGHT: '#fff'
}

const VariantType = {
  MATERIAL: 'material',
  MODEL: 'model'
}

const Variants = {
  N0: { id: 'N0', type: VariantType.MATERIAL, text: '4-nohá ocelová podnož v povrchové úpravě bílá prášková barva' },
  N1: { id: 'N1', type: VariantType.MATERIAL, text: '4-nohá ocelová podnož v povrchové úpravě černá prášková barva' },
  N2: { id: 'N2', type: VariantType.MATERIAL, text: '4-nohá ocelová podnož v povrchové úpravě šedá prášková barva (RAL 9006)' },
  N4: { id: 'N4', type: VariantType.MATERIAL, text: '4-nohá ocelová podnož v povrchové úpravě chrom' },
  SY: { id: 'SY', type: VariantType.MODEL, text: 'synchronní mechanika SY s nastavením tuhosti odporu pod sedákem, 5x aretace' },
  SYA: { id: 'SYA', type: VariantType.MODEL, text: 'synchronní mechanika SYA s automatickým přednastavením odporu opěráku s možností úpravy síly pomocí otočného voliče na pravé straně mechaniky, 5x aretace' },
  SYS: { id: 'SYS', type: VariantType.MODEL, text: 'synchronní mechanika SYS s bočním nastavením tuhosti odporu opěráku, 5x aretace' }
}

const VariantsMaterial: {[index: string]: VariantMaterial } = {
  N0: {
    color: 0xffffff,
    metalness: 0,
    roughness: 1
  },
  N1: {
    color: 0x030303,
    metalness: 0,
    roughness: 0.5
  },
  N2: {
    color: 0x444444,
    metalness: 0.5,
    roughness: 0.5
  },
  N4: {
    color: 0xffffff,
    emissive: 0x808080,
    metalness: 1,
    roughness: 0
  }
}

const Materials = [
  {
    name: 'Dino',
    values: [
      { name: 'Dino D1008', file: 'd1008.jpg' },
      { name: 'Dino D2036', file: 'd2036.jpg' },
      { name: 'Dino D3012', file: 'd3012.jpg' },
      { name: 'Dino D4011', file: 'd4011.jpg' },
      { name: 'Dino D4017', file: 'd4017.jpg' },
      { name: 'Dino D6003', file: 'd6003.jpg' },
      { name: 'Dino D6016', file: 'd6016.jpg' },
      { name: 'Dino D6098', file: 'd6098.jpg' },
      { name: 'Dino D7008', file: 'd7008.jpg' },
      { name: 'Dino D7048', file: 'd7048.jpg' },
      { name: 'Dino D8010', file: 'd8010.jpg' },
      { name: 'Dino D8033', file: 'd8033.jpg' }
    ]
  },
  {
    name: 'Era',
    values: [
      { name: 'Era CSE02', file: 'cse02.jpg' },
      { name: 'Era CSE05', file: 'cse05.jpg' },
      { name: 'Era CSE06', file: 'cse06.jpg' },
      { name: 'Era CSE08', file: 'cse08.jpg' },
      { name: 'Era CSE09', file: 'cse09.jpg' },
      { name: 'Era CSE10', file: 'cse10.jpg' },
      { name: 'Era CSE11', file: 'cse11.jpg' },
      { name: 'Era CSE12', file: 'cse12.jpg' },
      { name: 'Era CSE13', file: 'cse13.jpg' },
      { name: 'Era CSE14', file: 'cse14.jpg' },
      { name: 'Era CSE15', file: 'cse15.jpg' },
      { name: 'Era CSE16', file: 'cse16.jpg' },
      { name: 'Era CSE24', file: 'cse24.jpg' },
      { name: 'Era CSE25', file: 'cse25.jpg' },
      { name: 'Era CSE34', file: 'cse34.jpg' },
      { name: 'Era CSE39', file: 'cse39.jpg' }
    ]
  },
  {
    name: 'Florida',
    values: [
      { name: 'Florida F3082', file: 'f3082.jpg' },
      { name: 'Florida F4028', file: 'f4028.jpg' },
      { name: 'Florida F5003', file: 'f5003.jpg' },
      { name: 'Florida F5096', file: 'f5096.jpg' },
      { name: 'Florida F6071', file: 'f6071.jpg' },
      { name: 'Florida F7025', file: 'f7025.jpg' },
      { name: 'Florida F8017', file: 'f8017.jpg' },
      { name: 'Florida F8032', file: 'f8032.jpg' },
      { name: 'Florida F8033', file: 'f8033.jpg' }
    ]
  }
]

const chairConfig = [
  {
    name: 'Nido 1',
    file: 'nido1.glb',
    id: 'nido1',
    config: [
      { parts: ['sedak'], text: 'potah sedáku', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '100BL-N1' },
      { ...Variants.N2, code: '100BL-N2' },
      { ...Variants.N4, code: '100BL-N4' }
    ],
    colors: Materials,
    background: Background.LIGHT,
    floor: Floor.LIGHT,
    scale: 1
  },
  {
    name: 'Nido 1 Simple',
    file: 'nido1_simple.glb',
    id: 'nido1_simple',
    config: [
      { parts: ['sedak'], text: 'potah sedáku', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '100BL-N1' },
      { ...Variants.N2, code: '100BL-N2' },
      { ...Variants.N4, code: '100BL-N4' }
    ],
    colors: Materials,
    background: Background.LIGHT,
    floor: Floor.LIGHT,
    scale: 1
  },
  {
    name: 'Nido 3 Simple',
    file: 'nido3_simple.glb',
    id: 'nido3_simple',
    config: [
      { parts: ['sedak'], text: 'potah sedáku', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '100BL-N1' },
      { ...Variants.N2, code: '100BL-N2' },
      { ...Variants.N4, code: '100BL-N4' }
    ],
    colors: Materials,
    background: Background.LIGHT,
    floor: Floor.LIGHT,
    scale: 1
  },
  {
    name: 'Nido 2 Simple',
    file: 'nido2_simple.glb',
    id: 'nido2_simple',
    config: [
      { parts: ['sedak'], text: 'potah sedáku', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '100BL-N1' },
      { ...Variants.N2, code: '100BL-N2' },
      { ...Variants.N4, code: '100BL-N4' }
    ],
    colors: Materials,
    background: Background.LIGHT,
    floor: Floor.LIGHT,
    scale: 1
  },
  {
    name: 'Dream+ 100BL',
    file: 'dream+100BL.glb',
    id: 'dream+100BL',
    config: [
      { parts: ['sedak'], text: 'potah sedáku', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '100BL-N1' },
      { ...Variants.N2, code: '100BL-N2' },
      { ...Variants.N4, code: '100BL-N4' }
    ],
    colors: Materials,
    background: Background.LIGHT,
    floor: Floor.LIGHT,
    scale: 1
  },
  {
    name: 'Dream+ 100BL,BR',
    file: 'dream+100BLBR.glb',
    id: 'dream+100BLBR',
    config: [
      { parts: ['sedak'], text: 'potah sedáku', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '100BL-N1,BR' },
      { ...Variants.N2, code: '100BL-N2,BR' },
      { ...Variants.N4, code: '100BL-N4,BR' }
    ],
    colors: Materials,
    background: Background.LIGHT,
    floor: Floor.LIGHT,
    scale: 1
  },
  {
    name: 'Dream+ 100BL,BR,RM60',
    file: 'dream+100BLBRRM60.glb',
    id: 'dream+100BLBRRM60',
    config: [
      { parts: ['sedak'], text: 'potah sedáku', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '100BL-N1,BR,RM60' },
      { ...Variants.N2, code: '100BL-N2,BR,RM60' },
      { ...Variants.N4, code: '100BL-N4,BR,RM60' }
    ],
    colors: Materials,
    background: Background.LIGHT,
    floor: Floor.LIGHT,
    scale: 1
  },
  {
    name: 'Dream+ 100BL,RM60',
    file: 'dream+100BLRM60.glb',
    id: 'dream+100BLRM60',
    config: [
      { parts: ['sedak'], text: 'potah sedáku', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '100BL-N1,RM60' },
      { ...Variants.N2, code: '100BL-N2,RM60' },
      { ...Variants.N4, code: '100BL-N4,RM60' }
    ],
    colors: Materials,
    background: Background.LIGHT,
    floor: Floor.LIGHT,
    scale: 1
  },
  {
    name: 'Dream+ 100WH',
    file: 'dream+100WH.glb',
    id: 'dream+100WH',
    config: [
      { parts: ['sedak'], text: 'potah sedáku', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N0, code: '100WH-N0' },
      { ...Variants.N1, code: '100WH-N1' },
      { ...Variants.N2, code: '100WH-N2' },
      { ...Variants.N4, code: '100WH-N4' }
    ],
    colors: Materials,
    background: Background.DARK,
    floor: Floor.DARK,
    scale: 1
  },
  {
    name: 'Dream+ 100WH,BR',
    file: 'dream+100WHBR.glb',
    id: 'dream+100WHBR',
    config: [
      { parts: ['sedak'], text: 'potah sedáku', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N0, code: '100WH-N0,BR' },
      { ...Variants.N1, code: '100WH-N1,BR' },
      { ...Variants.N2, code: '100WH-N2,BR' },
      { ...Variants.N4, code: '100WH-N4,BR' }
    ],
    colors: Materials,
    background: Background.DARK,
    floor: Floor.DARK,
    scale: 1
  },
  {
    name: 'Dream+ 101BL-Z',
    file: 'dream+101BLZ.glb',
    id: 'dream+101BLZ',
    config: [
      { parts: ['sedak'], text: 'potah sedáku', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '101BL-Z-N1' },
      { ...Variants.N2, code: '101BL-Z-N2' },
      { ...Variants.N4, code: '101BL-Z-N4' }
    ],
    colors: Materials,
    background: Background.LIGHT,
    floor: Floor.LIGHT,
    scale: 1
  },
  {
    name: 'Dream+ 101BL-Z,BR',
    file: 'dream+101BLZBR.glb',
    id: 'dream+101BLZBR',
    config: [
      { parts: ['sedak'], text: 'potah sedáku', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '101BL-Z-N1,BR' },
      { ...Variants.N2, code: '101BL-Z-N2,BR' },
      { ...Variants.N4, code: '101BL-Z-N4,BR' }
    ],
    colors: Materials,
    background: Background.LIGHT,
    floor: Floor.LIGHT,
    scale: 1
  },
  {
    name: 'Dream+ 101WH-Z',
    file: 'dream+101WHZ.glb',
    id: 'dream+101WHZ',
    config: [
      { parts: ['sedak'], text: 'potah sedáku', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '101WH-Z-N1' },
      { ...Variants.N2, code: '101WH-Z-N2' },
      { ...Variants.N4, code: '101WH-Z-N4' }
    ],
    colors: Materials,
    background: Background.DARK,
    floor: Floor.DARK,
    scale: 1
  },
  {
    name: 'Dream+ 101WH-Z,BR',
    file: 'dream+101WHZBR.glb',
    id: 'dream+101WHZBR',
    config: [
      { parts: ['sedak'], text: 'potah sedáku', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '101WH-Z-N1,BR' },
      { ...Variants.N2, code: '101WH-Z-N2,BR' },
      { ...Variants.N4, code: '101WH-Z-N4,BR' }
    ],
    colors: Materials,
    background: Background.DARK,
    floor: Floor.DARK,
    scale: 1
  },
  {
    name: 'Dream+ 103BL',
    file: 'dream+103BL.glb',
    id: 'dream+103BL',
    config: [
      { parts: ['sedak', 'vnitrni-operka'], text: 'potah', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '103BL-N1' },
      { ...Variants.N2, code: '103BL-N2' },
      { ...Variants.N4, code: '103BL-N4' }
    ],
    colors: Materials,
    background: Background.LIGHT,
    floor: Floor.LIGHT,
    scale: 1
  },
  {
    name: 'Dream+ 103BL,BR',
    file: 'dream+103BLBR.glb',
    id: 'dream+103BLBR',
    config: [
      { parts: ['sedak', 'vnitrni-operka'], text: 'potah', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '103BL-Z-N1,BR' },
      { ...Variants.N2, code: '103BL-Z-N2,BR' },
      { ...Variants.N4, code: '103BL-Z-N4,BR' }
    ],
    colors: Materials,
    background: Background.LIGHT,
    floor: Floor.LIGHT,
    scale: 1
  },
  {
    name: 'Dream+ 103WH',
    file: 'dream+103WH.glb',
    id: 'dream+103WH',
    config: [
      { parts: ['sedak', 'vnitrni-operka'], text: 'potah', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N0, code: '103WH-N0' },
      { ...Variants.N1, code: '103WH-N1' },
      { ...Variants.N2, code: '103WH-N2' },
      { ...Variants.N4, code: '103WH-N4' }
    ],
    colors: Materials,
    background: Background.DARK,
    floor: Floor.DARK,
    scale: 1
  },
  {
    name: 'Dream+ 103WH,BR',
    file: 'dream+103WHBR.glb',
    id: 'dream+103WHBR',
    config: [
      { parts: ['sedak', 'vnitrni-operka'], text: 'potah', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N0, code: '103WH-N0,BR' },
      { ...Variants.N1, code: '103WH-N1,BR' },
      { ...Variants.N2, code: '103WH-N2,BR' },
      { ...Variants.N4, code: '103WH-N4,BR' }
    ],
    colors: Materials,
    background: Background.DARK,
    floor: Floor.DARK,
    scale: 1
  },
  {
    name: 'Dream+ 104BL-Z',
    file: 'dream+104BLZ.glb',
    id: 'dream+104BLZ',
    config: [
      { parts: ['sedak', 'vnitrni-operka'], text: 'potah', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '104BL-Z-N1' },
      { ...Variants.N2, code: '104BL-Z-N2' },
      { ...Variants.N4, code: '104BL-Z-N4' }
    ],
    colors: Materials,
    background: Background.LIGHT,
    floor: Floor.LIGHT,
    scale: 1
  },
  {
    name: 'Dream+ 104BL-Z,BR',
    file: 'dream+104BLZBR.glb',
    id: 'dream+104BLZBR',
    config: [
      { parts: ['sedak', 'vnitrni-operka'], text: 'potah', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '104BL-Z-N1,BR' },
      { ...Variants.N2, code: '104BL-Z-N2,BR' },
      { ...Variants.N4, code: '104BL-Z-N4,BR' }
    ],
    colors: Materials,
    background: Background.LIGHT,
    floor: Floor.LIGHT,
    scale: 1
  },
  {
    name: 'Dream+ 104WH-Z',
    file: 'dream+104WHZ.glb',
    id: 'dream+104WHZ',
    config: [
      { parts: ['sedak', 'vnitrni-operka'], text: 'potah', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '104WH-Z-N1' },
      { ...Variants.N2, code: '104WH-Z-N2' },
      { ...Variants.N4, code: '104WH-Z-N4' }
    ],
    colors: Materials,
    background: Background.DARK,
    floor: Floor.DARK,
    scale: 1
  },
  {
    name: 'Dream+ 104WH-Z,BR',
    file: 'dream+104WHZBR.glb',
    id: 'dream+104WHZBR',
    config: [
      { parts: ['sedak', 'vnitrni-operka'], text: 'potah', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.N1, code: '104WH-Z-N1,BR' },
      { ...Variants.N2, code: '104WH-Z-N2,BR' },
      { ...Variants.N4, code: '104WH-Z-N4,BR' }
    ],
    colors: Materials,
    background: Background.DARK,
    floor: Floor.DARK,
    scale: 1
  },
  {
    name: 'Leaf 503-SY',
    file: 'leaf503-SY.glb',
    id: 'leaf503-SY',
    config: [
      { parts: ['sit'], text: 'typ sítě', color: 'd8033.jpg', colorName: 'Dino D8033' },
      { parts: ['sedak', 'hlavova_operka'], text: 'potah', color: 'd8033.jpg', colorName: 'Dino D8033' },
      { parts: ['podnoz'], text: 'barvu podnože', color: 'd8033.jpg', colorName: 'Dino D8033' }
    ],
    variants: [
      { ...Variants.SY, code: '503-SY' },
      { ...Variants.SYA, code: '503-SYA' },
      { ...Variants.SYS, code: '503-SYS' }
    ],
    accessories: [
      {
        id: 'podrucky',
        text: 'Područky',
        values: [
          { id: 'podrucky', parts: ['podrucky'], text: 'Područky 1' },
          { id: 'podrucky', parts: ['podrucky_2'], text: 'Područky 2' },
          { id: 'podrucky', parts: ['podrucky_3'], text: 'Područky 3' }
        ]
      },
      {
        id: 'ostatni',
        text: 'Ostatní',
        values: [
          { id: 'hlavova_operka', parts: ['hlavova_operka', 'hlavova_operka_ram'], text: 'Hlavová opěrka' },
          { id: 'raminko', parts: ['raminko'], text: 'Ramínko' }
        ]
      }
    ],
    colors: Materials,
    background: Background.LIGHT,
    floor: Floor.LIGHT,
    scale: 0.75
  }
]

const ChairService = {
  getChair (id: string): Chair | undefined {
    return chairConfig.find(chair => chair.id === id)
  },
  getChairVariantMaterial (id: string): VariantMaterial {
    return VariantsMaterial[id]
  }
}

export { ChairService, Chair, VariantType }
